var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChat = function SvgIconChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1316CF",
    d: "m30.784 28.05.65 5.267c.166 1.383-1.317 2.35-2.5 1.633l-5.767-3.433c-.4-.233-.5-.733-.283-1.133a10.5 10.5 0 0 0 1.283-5c0-6.1-5.233-11.067-11.667-11.067-1.316 0-2.6.2-3.8.6-.616.2-1.216-.367-1.066-1C9.15 7.85 14.984 3.334 21.95 3.334c8.134 0 14.717 6.15 14.717 13.733 0 4.5-2.317 8.483-5.883 10.983"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1316CF",
    d: "M21.666 25.384c0 1.983-.733 3.816-1.966 5.266-1.65 2-4.267 3.284-7.2 3.284l-4.35 2.583c-.734.45-1.667-.167-1.567-1.017L7 32.217c-2.234-1.55-3.667-4.033-3.667-6.833 0-2.934 1.567-5.517 3.967-7.05 1.483-.967 3.266-1.517 5.2-1.517 5.066 0 9.166 3.833 9.166 8.567"
  })));
};
export default SvgIconChat;